import { AnimatePresence } from 'framer-motion'
import ClipLoader from 'react-spinners/ClipLoader'

import { useTheme } from '@apps-common/hooks/useTheme'
import { VertSpacerLg } from '../layout/spacers'

interface IProps {
  key?: string
  loading: boolean
}

export const InfiniteLoader: React.FC<IProps> = ({ key, loading }) => {
  const { resolvedTheme } = useTheme()

  return (
    <div className='flex flex-col items-center justify-center opacity-70'>
      <VertSpacerLg />
      <AnimatePresence>{loading && <ClipLoader color={resolvedTheme.textMuted} />}</AnimatePresence>
    </div>
  )
}
